import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import { isDesignThemeKey, type DesignThemeKey } from '@/components/design/themes';

const SELECTED_THEME_KEY = 'gaia-design-selected-theme';

function storedTheme(): DesignThemeKey {
  const value = localStorage.getItem(SELECTED_THEME_KEY);
  return isDesignThemeKey(value) ? value : 'gaia-light';
}

/**
 * The app's global theme choice. App.vue reads this for the real
 * n-config-provider, defaulting to 'gaia-light'; the /dev/design page reads
 * and writes the same store, so switching there changes (and persists) the
 * real app-wide theme rather than just a local preview.
 */
export const useDesignStore = defineStore('design', () => {
  const selectedTheme = ref<DesignThemeKey>(storedTheme());

  watch(selectedTheme, value => {
    localStorage.setItem(SELECTED_THEME_KEY, value);
  });

  return { selectedTheme };
});
